import React, { useEffect, useState } from "react";
import { useTable } from "react-table";
import DownArrow from "../../images/downarrow.svg";
import Privacypolicypopup from "../Popup/Privacypolicypopup";
import { useMutation, useLazyQuery } from "@apollo/react-hooks";
import { GET_TERM_OF_SERVICES } from "../../query/getTermOfServices";
import { hasuraClient } from "../../apolloClient";
import { Spinner, Dropdown } from "react-bootstrap";
import search from "../../images/search.svg";
import moment from "moment";
import { ACCEPT_TERM } from "../../mutation/acceptTerm";

const Termsofservice = () => {
  const [termData, setTermData] = useState([]);
  const [modalData, setModalData] = useState(null);

  const [
    getTermOfServices,
    { data: getTermOfServicesData, loading, error, refetch },
  ] = useLazyQuery(GET_TERM_OF_SERVICES, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
    variables: {
      order_by_last_update: "desc",
    },
  });

  const [acceptTerm] = useMutation(ACCEPT_TERM, {
    client: hasuraClient,
  });

  useEffect(() => {
    getTermOfServices({
      variables: {
        order_by_last_update: "desc",
      },
    });
  }, []);

  useEffect(() => {
    if (getTermOfServicesData && getTermOfServicesData.terms_of_services) {
      setTermData(getTermOfServicesData.terms_of_services);
    }
  }, [getTermOfServicesData]);

  const columns = React.useMemo(
    () => [
      {
        Header: "NAME",
        accessor: "name",
      },
      {
        Header: "LAST UPDATE",
        accessor: "last_update",
      },
      {
        Header: "DESCRIPTION",
        accessor: "description",
      },
      {
        Header: " ",
        accessor: "dots",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: termData });

  return (
    <>
      {modalData ? (
        <Privacypolicypopup
          show={modalData ? true : false}
          onHide={() => setModalData(false)}
          setModalData={setModalData}
          modalData={modalData}
          acceptTerm={acceptTerm}
          refetch={refetch}
        />
      ) : (
        ""
      )}
      <div className="terms-table">
        <div className="search-box">
          <input
            className="form-control"
            type="search"
            name="search"
            placeholder="Search..."
            onChange={(e) => {
              getTermOfServices({
                variables: {
                  search_text: `%${e.target.value}%`,
                  order_by_last_update: "desc",
                },
              });
            }}
          />
          <button className="search-btn">
            <img src={search} alt="search" />
          </button>
        </div>
        <table {...getTableProps()} className="table termsofservice-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                    {column.id === "dots" ? (
                      ""
                    ) : (
                      <span>
                        <img src={DownArrow} />
                      </span>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length ? (
              rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>
                          {cell.column.id === "name" ? (
                            <a
                              href="javascript:void(0)"
                              style={{ color: "black" }}
                              onClick={() => {
                                acceptTerm({
                                  variables: {
                                    id: cell.row.original.id,
                                    is_read: true,
                                    is_accepted:
                                      cell.row.original
                                        ?.terms_of_services_read_or_accepted[0]
                                        ?.is_accepted,
                                  },
                                })
                                  .then(() => {
                                    refetch();
                                  })
                                  .catch(() => {});
                                setModalData(cell.row.original);
                              }}
                            >
                              {" "}
                              {cell.value}{" "}
                            </a>
                          ) : cell.column.id === "last_update" ? (
                            moment(cell.value).format("DD.MM.YYYY")
                          ) : cell.column.id === "dots" ? (
                            <>
                              {!cell.row.original
                                .terms_of_services_read_or_accepted[0]
                                ?.is_accepted ? (
                                <div className="toggle">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <span></span>
                                      <span></span>
                                      <span></span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                          acceptTerm({
                                            variables: {
                                              id: cell.row.original.id,
                                              is_read: true,
                                              is_accepted: true,
                                            },
                                          }).then(() => {
                                            refetch();
                                          });
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="10"
                                          viewBox="0 0 14 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M4.9375 9.71349L0.8125 5.58849L1.99083 4.41016L4.93875 7.35474L4.9375 7.35599L12.0083 0.285156L13.1867 1.46349L6.11583 8.53515L4.93833 9.71265L4.9375 9.71349Z"
                                            fill="#989DB2"
                                          />
                                        </svg>
                                        Accept
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          acceptTerm({
                                            variables: {
                                              id: cell.row.original.id,
                                              is_read: true,
                                              is_accepted: false,
                                            },
                                          }).then(() => {
                                            refetch();
                                          });
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M11.9164 13.1451C12.2558 13.4844 12.8061 13.4844 13.1455 13.1451C13.4849 12.8057 13.4849 12.2553 13.1455 11.9159L8.2292 6.99959L13.1456 2.08325C13.4849 1.74384 13.4849 1.19357 13.1456 0.854162C12.8061 0.514759 12.2558 0.514759 11.9164 0.854162L7.00008 5.77047L2.08373 0.854173C1.74433 0.514769 1.19405 0.514769 0.85465 0.854173C0.515247 1.19358 0.515247 1.74387 0.85465 2.08327L5.77097 6.99959L0.854661 11.9159C0.515258 12.2553 0.515258 12.8056 0.854661 13.1451C1.19406 13.4844 1.74434 13.4844 2.08375 13.1451L7.00008 8.2287L11.9164 13.1451Z"
                                            fill="#989DB2"
                                          />
                                        </svg>
                                        Not now
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          ) : cell.column.id === "description" ? (
                            <p>
                              {cell?.row?.original?.description?.slice(0, 40)}
                              {cell?.row?.original?.description?.length > 40
                                ? "..."
                                : ""}
                            </p>
                          ) : (
                            ""
                          )}
                          {cell.column.id === "last_update" ? (
                            <>
                              {!cell.row.original
                                ?.terms_of_services_read_or_accepted[0]
                                ?.is_read ? (
                                <span>New update</span>
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : loading ? (
              <div className="spinner-cover">
                <Spinner className="spinner" animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : error ? (
              <p className="no-data-found">"some error occurred..."</p>
            ) : (
              <p className="no-data-found">"No Data Found..."</p>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Termsofservice;
